module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dashboardFlags.evsensAdminFlag === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayFilter === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayFilter) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelFilters[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayFilter === -1) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_c('i', {
      staticClass: "fa fa-tags fa-1x push-5-r "
    }), _vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attributesFiltersChoice[index]),
        expression: "attributesFiltersChoice[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-multiple-select",
        "name": "example-multiple-select",
        "size": "4",
        "multiple": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.attributesFiltersChoice, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.attributesFilters[index]), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetDisplayFlag()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelEraseFilter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonApplyFilters[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPie()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonPieChartRefresh[_vm.actualLanguage]))])])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMap === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMap) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelDeviceLocalisation[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMap === -1) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.showListOfChannel) ? _c('div', {
    staticClass: "row"
  }, [_c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": 8,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "label": marker.label,
        "draggable": false
      }
    })
  }), 1)], 1) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [(_vm.showPieChart && _vm.crunchedCost.datasets[0].data.length > 0 && _vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag) ? _c('div', {
    staticClass: "block-content push"
  }, [(_vm.flagDisplayOldGraph) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelPieConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedCunsumption
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayOldGraph) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelPieCost[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedCost
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayOldGraph) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelPieMaximumCurrent[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedMaxCurrent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-6"
  }, [_c('h3', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelPieConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "options": _vm.pieChartOptionsKWH,
      "series": _vm.pieChartDataSeriesKWH
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-6"
  }, [_c('h3', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelPieCost[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "options": _vm.pieChartOptionsCost,
      "series": _vm.pieChartDataSeriesCost
    }
  })], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.displayAsTableFlag) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push align-center"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayDetail[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.EvSenschannelCounter > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGraphCurve),
      expression: "selectedGraphCurve"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.updatePieChartData()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGraphCurve = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AvrPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorAvrPowerKW[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PeakPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPeakPowerKW[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KWH_PerSample"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorKWHShort[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cost_PerSample"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCostShort[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CumSumKWH"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CumSumCost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumCost[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  })]) : _vm._e(), _vm._v(" "), (_vm.EvSenschannelCounter > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push align-center"
  }, [_c('h6', {
    staticClass: "font-w200 align-center push"
  }, [_vm._v(_vm._s(_vm.textLabelRequireDeviceSelect[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table remove-margin-b font-s12"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelDevice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelOnline[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelMaxCurrent[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelCunsumption[_vm.actualLanguage]))]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelLastReading[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_1Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_4Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_6Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_12Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_1Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_3Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_7Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_14Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_30Day[_vm.actualLanguage]))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.subBundleDisplayFlag), function(flag, index) {
    return _c('tr', [(flag) ? _c('td', {
      staticClass: "font-w600"
    }, [(_vm.actualBundle.sub_bundle[index].subBundleData.bundle_icon == 'Undefined.png') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _c('img', {
      staticClass: "measurement-graph-row__icon",
      attrs: {
        "width": "50px",
        "src": _vm._f("s3Image")(("systems_icons/" + (_vm.actualBundle.sub_bundle[index].subBundleData.bundle_icon))),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (flag) ? _c('td', [_vm._v("X")]) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(index + 1) + " : " + _vm._s(_vm.actualBundle.sub_bundle[index].ReferenceName))]) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': '5min'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_001H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_004H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_006H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_012H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_024H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_072H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_168H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_336H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_720H'
        }
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index) {
    return _c('tr', [(flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600"
    }, [(_vm.actualBundle.channels[index].ChannelData.channelInfo.iconFile == 'Undefined.png') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _c('img', {
      staticClass: "measurement-graph-row__icon",
      attrs: {
        "width": "50px",
        "src": _vm._f("s3Image")(("appliances/" + (_vm.actualBundle.channels[index].ChannelData.channelInfo.iconFile))),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600",
      on: {
        "click": function($event) {
          return _vm.toggleChannelDisplayFlag(index)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag),
        expression: "actualBundle.channels[index].ChannelData.DisplayOpenFlag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag) ? _vm._i(_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag, null) > -1 : (_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.actualBundle.channels[index].ChannelData, "DisplayOpenFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.actualBundle.channels[index].ChannelData, "DisplayOpenFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.actualBundle.channels[index].ChannelData, "DisplayOpenFlag", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(index + 1) + " : " + _vm._s(_vm.actualBundle.channels[index].ReferenceName))]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600"
    }, [(_vm.actualBundle.channels[index].ChannelData.deviceOnline) ? _c('i', {
      staticClass: "fa fa-toggle-on fa-2x"
    }) : _c('i', {
      staticClass: "fa fa-toggle-off fa-2x"
    })]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(_vm._f("round")(_vm.actualBundle.channels[index].ChannelData.peakCurrent)) + " A")]) : (flag) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(_vm._f("round")(_vm.actualBundle.channels[index].ChannelData.sumKwh)) + " kWh/ " + _vm._s(_vm._f("toCurrency")(_vm.actualBundle.channels[index].ChannelData.sumCost)))]) : (flag) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': '5min'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_001H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_004H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_006H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_012H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_024H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_072H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_168H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_336H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_720H'
        }
      }
    })], 1) : _vm._e()])
  })], 2)])])]), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index2) {
    return _c('div', [(flag && _vm.actualBundle.channels[index2].FrontendTemplates.componentChannelDisplay == 'ApiDevice_V1P00') ? _c('div', [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-xs-4 col-sm-3"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [(flag) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag),
        expression: "actualBundle.channels[index2].ChannelData.DisplayOpenFlag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag) ? _vm._i(_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag, null) > -1 : (_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.actualBundle.channels[index2].ChannelData, "DisplayOpenFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.actualBundle.channels[index2].ChannelData, "DisplayOpenFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.actualBundle.channels[index2].ChannelData, "DisplayOpenFlag", $$c)
          }
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('h5', {
      staticClass: "font-w300 push measurement-graph-row__title"
    }, [_c('img', {
      staticClass: "measurement-graph-row__icon",
      attrs: {
        "width": "60px",
        "src": _vm._f("s3Image")(("organization_img/" + (_vm.actualBundle.channels[index2].ChannelData.channelInfo.iconFile))),
        "alt": ""
      }
    }), _vm._v("\n              " + _vm._s(_vm.actualBundle.channels[index2].ReferenceName) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-9"
    }, [_c('api-device-list-indicator-v1p00', {
      attrs: {
        "componentListIndicators": _vm.actualBundle.channels[index2].ChannelData.Readings.listIndicators
      }
    })], 1)])]) : _vm._e()])
  })], 2) : _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push align-center"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDisplayList[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.showListOfChannel) ? _c('div', [(_vm.actualBundle['sub_bundle'].length) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelSubSystem[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.subBundleDisplayFlag), function(flag, index) {
    return _c('div', [(flag) ? _c('display-sub-bundle', {
      attrs: {
        "subBundleIndex": index
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.actualBundle['channels'].length) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelSubDevice[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index) {
    return _c('div', [(flag && _vm.actualBundle.channels[index].FrontendTemplates.componentChannelDisplay == 'EVA_V1P00') ? _c('display-channel', {
      attrs: {
        "channelIndex": index
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index2) {
    return _c('div', [(flag && _vm.actualBundle.channels[index2].FrontendTemplates.componentChannelDisplay == 'ApiDevice_V1P00') ? _c('api-display-channel-v1p00', {
      attrs: {
        "channelIndex": index2
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52a2a6e5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/DisplayChannelList.vue
// module id = 1539
// module chunks = 4